import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { UserNotificationInput } from '../../../shared/data/inputs/user-notification.input';
import { myNotificationQuery } from '../../../shared/data/gql/query/my-notification.query';
import { MyNotificationResponse } from '../../../shared/data/responses/my-notification.response';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';
import { readNotificationMutation } from '../../../shared/data/gql/mutation/read-notification.mutation';
import { ReadNotificationInput } from '../../../shared/data/inputs/read-notification.input';
import { ReadNotificationResponse } from '../../../shared/data/responses/read-notification.response';
import { FetchResult } from 'apollo-link';
import { DeleteNotificationInput } from '../../../shared/data/inputs/delete-notification.input';
import { deleteNotificationMutation } from '../../../shared/data/gql/mutation/delete-notification.mutation';
import { DeleteNotificationResponse } from '../../../shared/data/responses/delete-notification.response';
import { ReadAllNotificationsResponse } from '../../../shared/data/responses/read-all-notifications.response';
import { readAllNotificationsMutation } from '../../../shared/data/gql/mutation/read-all-notifications.mutation';
import { DeleteAllNotificationsResponse } from '../../../shared/data/responses/delete-all-notifications.response';
import { deleteAllNotificationsMutation } from '../../../shared/data/gql/mutation/delete-all-notifications.mutation';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  constructor(private apollo: Apollo) {}

  getAllNotifications(
    input: UserNotificationInput
  ): Observable<ApolloQueryResult<MyNotificationResponse>> {
    return this.apollo.query<MyNotificationResponse>({
      query: myNotificationQuery,
      variables: input
    });
  }

  readNotification(
    input: ReadNotificationInput
  ): Observable<FetchResult<ReadNotificationResponse>> {
    return this.apollo.mutate<ReadNotificationResponse>({
      mutation: readNotificationMutation,
      variables: input
    });
  }

  deleteNotification(
    input: DeleteNotificationInput
  ): Observable<FetchResult<DeleteNotificationResponse>> {
    return this.apollo.mutate<DeleteNotificationResponse>({
      mutation: deleteNotificationMutation,
      variables: input
    });
  }

  readAllNotifications(): Observable<
    FetchResult<ReadAllNotificationsResponse>
  > {
    return this.apollo.mutate<ReadAllNotificationsResponse>({
      mutation: readAllNotificationsMutation
    });
  }

  deleteAllNotifications(): Observable<
    FetchResult<DeleteAllNotificationsResponse>
  > {
    return this.apollo.mutate<DeleteAllNotificationsResponse>({
      mutation: deleteAllNotificationsMutation
    });
  }
}
